import React, { useMemo } from "react";
import StaticMapboxComponent from "@/components/Common/StaticMapboxComponent";

const parseDrawnPolygon = (drawnPolygonText) => {
  if (!drawnPolygonText) return null;
  const match = drawnPolygonText.match(/POLYGON\(\((.+)\)\)/i);
  if (!match) return null;
  const coords = match[1].split(",").map((pair) => {
    const [lng, lat] = pair.trim().split(/\s+/).map(Number);
    return { lng, lat };
  });
  return [[coords]];
};

const AgentBuyerMap = ({ wantAd, width = 452, height = 164 }) => {
  const { Longitude, Latitude, Radius, DrawnPolygonText } = wantAd || {};

  const drawnPolygonCoords = useMemo(
    () => parseDrawnPolygon(DrawnPolygonText),
    [DrawnPolygonText],
  );

  if (Longitude == null || Latitude == null) return null;

  return (
    <StaticMapboxComponent
      padding={20}
      width={width}
      height={height}
      center={[Longitude, Latitude]}
      radiusMiles={drawnPolygonCoords ? null : Radius}
      polygonCoordinates={drawnPolygonCoords}
      showPolygon={!!drawnPolygonCoords}
    />
  );
};

export default AgentBuyerMap;
